import { IJobTitleState, IStore } from '../../types';

export const selectJobTitlesBySite =
  (siteId: string) =>
  (state: IStore): IJobTitleState[] | undefined =>
    state?.collections?.jobs?.[siteId];
